










































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import centrosModule from "@/store/modules/centros-module";
import { centros } from "@/shared/dtos/centros";

declare global {
  interface Window {
    google: any;
  }
}

@Component({
  components: {},
})
export default class GpsFichajes extends Vue {
  // --- Configuración Mapa ---
  public center = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;

  // --- Datos ---
  public selectedCentro: number | null = null;
  public selectedGroups: string[] = [];
  public loading = false;

  // --- InfoWindow ---
  public infoWindowOpened = false;
  public infoWindowOptions = {
    pixelOffset: { width: 0, height: -35 },
  };
  public infoWindowPosition: any = null;
  public infoWindowContent: any = {};

  // --- Computed ---
  public get centrosOptions() {
    return centrosModule.centroses;
  }

  get gruposOptions() {
    const grupos = this.centrosOptions
      .map((c) => (c.grupo && c.grupo.nombre ? c.grupo.nombre : "Sin Grupo"))
      .filter((v, i, a) => a.indexOf(v) === i);
    return grupos.sort();
  }

  get centrosFiltradosPorGrupo() {
    // Si el array está vacío, devolvemos todo
    if (!this.selectedGroups || this.selectedGroups.length === 0)
      return this.centrosOptions;

    return this.centrosOptions.filter((c) => {
      const grupoNombre =
        c.grupo && c.grupo.nombre ? c.grupo.nombre : "Sin Grupo";
      // Verificamos si el grupo del centro está incluido en los seleccionados
      return this.selectedGroups.includes(grupoNombre);
    });
  }

  get selectedCentroNombre() {
    if (!this.selectedCentro) return "";
    const centro = this.centrosOptions.find(
      (c) => c.id === this.selectedCentro
    );
    return centro ? centro.nombre : "";
  }

  get markers() {
    return centrosModule.centroses.map((x: centros) => {
      return {
        position: {
          lat: Number.parseFloat(String(x.latitud).replace(",", ".")),
          lng: Number.parseFloat(String(x.longitud).replace(",", ".")),
        },
        nombre: x.nombre,
        direccion: x.direccion,
        codigo: x.codigo_sucursal,
        id: x.id,
        grupo: x.grupo && x.grupo.nombre ? x.grupo.nombre : "Sin Grupo",
      };
    });
  }

  get filteredMarkers() {
    let result = this.markers;

    // Filtro por MÚLTIPLES grupos
    if (this.selectedGroups && this.selectedGroups.length > 0) {
      result = result.filter((m) => this.selectedGroups.includes(m.grupo));
    }

    // Filtro por centro específico
    if (this.selectedCentro) {
      const selectedMarker = result.find(
        (marker) => marker.id === this.selectedCentro
      );
      if (selectedMarker) {
        this.center = selectedMarker.position;
        this.zoom = 15;
        return [selectedMarker];
      }
    }

    // Si hay grupos seleccionados pero no centro, ajustar zoom para ver todos
    if (this.selectedGroups.length > 0 && !this.selectedCentro) {
      this.calculateCenter(result);
      // Ajustamos el zoom dinámicamente o lo dejamos fijo un poco más cerca
      this.zoom = 10;
    } else if (this.selectedGroups.length === 0 && !this.selectedCentro) {
      // Reset opcional si no hay nada seleccionado
      this.zoom = 6.5;
    }

    return result;
  }

  // --- Lifecycle ---
  async created() {
    await centrosModule.getcentroses();
    this.calculateCenter(this.markers);
  }

  // --- Métodos ---
  public async buscar() {
    await centrosModule.getcentroses();
    this.calculateCenter(this.markers);
  }

  onZoomChanged(newZoom: number) {
    this.zoom = newZoom;
  }

  public localizarUsuario() {
    if (!navigator.geolocation) {
      this.mostrarSnackbar("Geolocalización no soportada", "error");
      return;
    }

    this.loading = true;
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        this.center = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        this.zoom = 16;
        this.loading = false;
        this.mostrarSnackbar("Ubicación encontrada", "success");
      },
      (err) => {
        console.error(err);
        this.mostrarSnackbar("Error al obtener ubicación", "error");
        this.loading = false;
      }
    );
  }

  openInfoWindow(index: number) {
    const marker = this.filteredMarkers[index];
    this.infoWindowPosition = marker.position;
    this.infoWindowContent = marker;
    this.infoWindowOpened = true;
  }

  closeInfoWindow() {
    this.infoWindowOpened = false;
  }

  abrirEnMaps(pos: any) {
    if (!pos) return;
    window.open(
      `https://www.google.com/maps?q=${pos.lat},${pos.lng}`,
      "_blank"
    );
  }

  customMarker() {
    return {
      url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
      scaledSize: { width: 45, height: 45 },
    };
  }

  calculateCenter(locations: any[]) {
    if (locations.length === 0) return;
    let totalLat = 0;
    let totalLng = 0;
    locations.forEach((location) => {
      totalLat += location.position.lat;
      totalLng += location.position.lng;
    });
    this.center = {
      lat: totalLat / locations.length,
      lng: totalLng / locations.length,
    };
  }

  // --- Snackbar ---
  public snackbar = {
    show: false,
    text: "",
    color: "success",
  };

  mostrarSnackbar(text: string, color: string) {
    this.snackbar.text = text;
    this.snackbar.color = color;
    this.snackbar.show = true;
  }
}
